import React from 'react';
import MobileDetect from 'mobile-detect/mobile-detect.js';

const detect = new MobileDetect(window.navigator.userAgent);

const isMobile = detect.mobile() !== null;
const isDesktop = !isMobile;

export const deviceType = {
  isMobile,
  isDesktop
};

export const DeviceTypeContext = React.createContext(deviceType);
